import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authAxioInstance from "../../services/authAxioInstance";
import Cookies from "js-cookie";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (signupData, { rejectWithValue }) => {
    try {
      const response = await authAxioInstance.post(`/EsignServices/NewAddCompanyForSignup`,
        signupData,
        {
            headers: {
                Authorization: "Bearer db1f5b8aa30d11efaa93c58cf55b45c8db1f5b8a",
                "Authorization-key": "d7f4e2caa0b1493ab8cf891d70a36f4d9c0a5e8c73e64fb1b3f3d3f42c8a56e4"
            },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.data;
        state.token = "token";
        state.isAuthenticated = true;
        Cookies.set("token", "static-token-123", { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      });
  },
});

export default signupSlice.reducer;
